import { Box } from "@mantine/core"

import classes from 'styles/display.module.css';

const CustomContainer = ({ children }: any) => {

  return (
    <Box className={classes.container}>
      {children}
    </Box>
  )
}

export default CustomContainer;